// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"10789a51","124":"1cb2a076"}[chunkId] + ".chunk.js";
};